import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { Col, Divider, Row, Space, Spin } from 'antd'
import { isEmpty } from 'lodash'

import { UpdateDataText } from '../../../core/components/sections'

import {
  CategoryBreadcrumbs,
  HistoryLink,
} from '../../../common/components/sections'
import { StyledPageSubTitle } from '../../../common/components/styled'
import { APP_ROUTES, EVENT_METADATA_TYPES } from '../../../common/constants'
import { showErrorNotification } from '../../../common/helpers'
import { useDocumentTitle } from '../../../common/hooks'

import { renderLocationTypeEvent } from '../../helpers'
import { useLocationTypeQuery } from '../../hooks'
import {
  LocationTypeImageDetailsForm,
  LocationTypeSimpleDetailsForm,
} from '../forms'

const LocationTypeDetailsPage = () => {
  const { id } = useParams()

  const {
    isLoading: isFetchLoading,
    error: fetchError,
    data,
  } = useLocationTypeQuery(id)

  useDocumentTitle(`${data?.name || 'Loading Location Type...'}`)

  useEffect(() => {
    if (fetchError) {
      showErrorNotification({
        title: 'Location Type error',
        description: fetchError,
      })
    }
  }, [fetchError])

  return isFetchLoading || isEmpty(data) ? (
    <Spin />
  ) : (
    <>
      <StyledPageSubTitle>
        <Row justify="space-between">
          <Col span={12}>
            <CategoryBreadcrumbs
              idPath={data.node.idPath}
              namePath={data.node.namePath}
              rootAppRoute={APP_ROUTES.LOCATION_TYPES}
              categoryAppRoute={APP_ROUTES.LOCATION_TYPE_CATEGORIES}
            />
          </Col>

          <Space>
            <UpdateDataText
              updatedAt={data.updatedAt}
              updatedBy={data.updatedBy?.name}
            />

            <HistoryLink
              renderEvent={renderLocationTypeEvent}
              entityId={id}
              eventMetadataTypes={[EVENT_METADATA_TYPES.LOCATION_TYPE]}
            />
          </Space>
        </Row>
      </StyledPageSubTitle>
      <LocationTypeSimpleDetailsForm
        id={data.id}
        name={data.name}
        description={data.description}
        synonyms={data.synonyms}
        maxPosition={data.maxPosition}
        position={data.position}
        isExcludedFromSearch={data.isExcludedFromSearch}
        isExcludedFromBrowsing={data.isExcludedFromBrowsing}
      />
      <Divider />
      <LocationTypeImageDetailsForm locationType={data} />
    </>
  )
}

export default LocationTypeDetailsPage
